import { render, staticRenderFns } from "./input-widget.vue?vue&type=template&id=6a36e16c&scoped=true&"
import script from "./input-widget.vue?vue&type=script&lang=js&"
export * from "./input-widget.vue?vue&type=script&lang=js&"
import style0 from "./input-widget.vue?vue&type=style&index=0&id=6a36e16c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a36e16c",
  null
  
)

export default component.exports